import { useLikeLimits } from './useLikeLimits';
import { useProfileViewLimits } from './useProfileViewLimits';
import { useNewConversationLimits } from './useNewConversationLimits';
import { useBoosts } from './useBoosts';

export const useMyPlanLimits = () => {
  const { likeLimits, loading: likesLoading } = useLikeLimits();
  const { viewLimits, loading: viewsLoading } = useProfileViewLimits();
  const { conversationLimits, loading: conversationsLoading } = useNewConversationLimits();
  const { availableBoosts, usedBoosts, loading: boostsLoading } = useBoosts();

  const isLoading = likesLoading || viewsLoading || conversationsLoading || boostsLoading;

  return {
    likes: {
      current: likeLimits.current,
      limit: likeLimits.limit,
      remaining: likeLimits.remaining,
      canLike: likeLimits.canLike,
      isUnlimited: likeLimits.isUnlimited
    },
    profileViews: {
      current: viewLimits.current,
      limit: viewLimits.limit,
      remaining: viewLimits.remaining,
      canView: viewLimits.canView,
      isUnlimited: viewLimits.isUnlimited
    },
    newConversations: {
      current: conversationLimits.current,
      limit: conversationLimits.limit,
      remaining: conversationLimits.remaining,
      canStart: conversationLimits.canStart,
      isUnlimited: conversationLimits.isUnlimited
    },
    boosts: {
      available: availableBoosts,
      used: usedBoosts
    },
    isLoading
  };
};
